export { default } from "./chart1";


// WEBPACK FOOTER //
// ./src/components/chart1/index.js